import { render } from "./pcInput.vue?vue&type=template&id=36fed719&scoped=true"
import script from "./pcInput.vue?vue&type=script&lang=js"
export * from "./pcInput.vue?vue&type=script&lang=js"

import "./pcInput.vue?vue&type=style&index=0&id=36fed719&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fed719"]])

export default __exports__